import axios, { AxiosPromise } from 'axios';

export interface IEmiseKorpAkce {
    sezemise: ISezemiseKorpAkce[];
}
export interface ISezemiseKorpAkce {
    isin: string;
    nazevemise: string;
    lei: string;
}
const emiseApi = (): AxiosPromise<IEmiseKorpAkce> => {
    return axios({
        method: 'GET',
        url: 'SRD/Emise'
    });
};
export default emiseApi;
